import { ref } from 'vue'

// Single entry point for opening the booking sheet from anywhere
// (price cards, offer pills, hero/header/sticky CTAs in later phases).
// Module-level state, same pattern as useTenantConfig.

const isOpen = ref(false)
const request = ref(null)
const seq = ref(0)

let prefetchPromise = null

const open = ({ serviceId = null, massageTypeId = null, source = 'unknown' } = {}) => {
    seq.value += 1
    request.value = { serviceId, massageTypeId, source, seq: seq.value }
    isOpen.value = true
}

const close = () => {
    isOpen.value = false
}

// Warm the async chunk before the user needs it (idempotent).
const prefetch = () => {
    if (!prefetchPromise) {
        prefetchPromise = import('@/components/BookingSheet.vue').catch(() => {
            prefetchPromise = null
        })
    }
    return prefetchPromise
}

export const useBookingSheet = () => ({ isOpen, request, open, close, prefetch })
